import axios from 'axios';
import { getAccessToken, getCsrfToken } from '../../../lib/tokenStore';

const API_BASE_URL = process.env.REACT_APP_OPPORTUNITY_API_URL ? process.env.REACT_APP_OPPORTUNITY_API_URL.replace('/opportunities', '') : 'http://localhost:81/api/vc/v1';

// Create a dedicated Axios instance for notifications
const notificationsAxios = axios.create({
  withCredentials: true,
  baseURL: `${API_BASE_URL}/notifications`,
});

// Request interceptor to attach the JWT token
notificationsAxios.interceptors.request.use((config) => {
  const csrf = getCsrfToken();
  if (csrf) config.headers['x-csrf-token'] = csrf;

  const token = getAccessToken();
  if (token) config.headers['Authorization'] = `Bearer ${token}`;
  return config;
});

// Response interceptor to automatically unwrap { success, data, message }
notificationsAxios.interceptors.response.use(
  (response) => {
    if (response.data && response.data.success !== undefined) {
      return response.data.data;
    }
    return response.data;
  },
  (error) => Promise.reject(error)
);

export const getUserNotifications = async () => {
  return notificationsAxios.get('/');
};

export const markAsRead = async (id) => {
  return notificationsAxios.put(`/${id}/read`);
};

export const markAllAsRead = async () => {
  return notificationsAxios.put('/read-all');
};

export const deleteNotification = async (id) => {
  return notificationsAxios.delete(`/${id}`);
};
